module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('photo-admin-header'), _vm._v(" "), _c('intro'), _vm._v(" "), _c('section-intro', {
    attrs: {
      "title": _vm.$t('message.title.site.photo_admin')
    }
  }), _vm._v(" "), _c('photo-admin', {
    attrs: {
      "car-id": _vm.$route.params.id
    }
  }), _vm._v(" "), _c('photo-admin-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-830710f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CarPhotoAdmin.vue
// module id = 1215
// module chunks = 1